export default __webpack_public_path__ + "static/media/nutshell.8ccff915.jpg";